<!-- 单独审批列表 -->
<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form" @reset="reset" @select-data="handleSelectionChange">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.merchantName')">
            <el-select
                v-model="form.appId"
                filterable
                :placeholder="$t('message.chooseOne')"
                popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                  v-for="merchant in merchantList"
                  :label="merchant.value + '-' + merchant.name"
                  :key="merchant.value"
                  :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.creditStatus')">
            <el-select v-model="form.status" :placeholder="$t('text.status')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('withdrawalStatus.00')" value="00"></el-option>
              <el-option :label="$t('withdrawalStatus.01')" value="01"></el-option>
              <el-option :label="$t('withdrawalStatus.02')" value="02"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.settlementStatus')">
            <el-select v-model="form.settlementStatus"
                       :placeholder="$t('text.settlementStatus')">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option :label="$t('settlementStatus.00')"
                         value="00"/>
              <el-option :label="$t('settlementStatus.01')"
                         value="01"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.orderNumber')">
            <el-input v-model="form.orderId" :placeholder="$t('text.orderNumber')" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.date')">
            <el-date-picker
                v-model="timeDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
                :range-separator="$t('text.to')"
                :start-placeholder="$t('text.startDate')"
                :end-placeholder="$t('text.endDate')"
                @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button
              type="info"
              size="small"
              @click="handleSettleAll"
              :loading="loading"
              :disabled="multipleSelection.length === 0"
              v-if="!ROLE_TYPE.isBusinessCustomerServiceManage()"
          >{{ $t('text.settle') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column type="selection" width="50" align="center" :selectable="selectable"></el-table-column>

          <el-table-column
              width="180px"
              prop="orderId"
              :label="$t('text.orderNumber')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="status"
              :label="$t('text.creditStatus')"
              width="80px"
              :formatter="$formatter.formatCreditStatus"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                  size="small"
                  :type="row.status === '00'? 'warning': row.status === '01'? 'success': 'danger'"
              >{{
                  $formatter.formatCreditStatus(null, null, row.status, null)
                }}
              </el-tag
              >
            </template>
          </el-table-column>

          <el-table-column prop="settlementStatus"
                           :formatter="$formatter.formatSettlementStatus"
                           width="80px"
                           :label="$t('text.whetherToSettle')"
                           align="center"/>

          <el-table-column
              width="170px"
              prop="appId"
              :label="$t('text.appId')"
              align="center"
          ></el-table-column>
          <el-table-column
              width="120px"
              prop="merchantName"
              :label="$t('text.merchantName')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="balance"
              :formatter="$formatter.FenToYuanToThousandth"
              width="120px"
              :label="$t('text.balance')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="freezeBalance"
              :formatter="$formatter.FenToYuanToThousandth"
              width="120px"
              :label="$t('text.frozenAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="availableAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              width="120px"
              :label="$t('text.creditAvailableAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="grantedAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              width="120px"
              :label="$t('text.creditGrantedAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="amount"
              :formatter="$formatter.FenToYuanToThousandth"
              width="120px"
              :label="$t('text.creditAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="150px"
              prop="createTimeFormat"
              :label="$t('text.creationTime')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="160px"
              prop="remark"
              :label="$t('text.applicationNote')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.remark">
                <el-popover
                    v-if="row.remark.length > 10"
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="row.remark"
                >
                  <div slot="reference" class="remark">{{ row.remark }}</div>
                </el-popover>
                <div v-else>{{ row.remark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              width="150px"
              prop="dealTimeFormat"
              :label="$t('text.processingTime')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="160px"
              prop="approveRemark"
              :label="$t('text.approvalRemark')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.approveRemark">
                <el-popover
                    v-if="row.approveRemark && row.approveRemark.length > 10"
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="row.approveRemark"
                >
                  <div slot="reference" class="remark">
                    {{ row.approveRemark }}
                  </div>
                </el-popover>
                <div v-else>{{ row.approveRemark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
              fixed="right"
              :label="$t('text.actions')"
              width="210px"
              align="center"
              v-if="ROLE_TYPE.isManager() && !ROLE_TYPE.isBusinessCustomerServiceManage()"
          >
            <template slot-scope="{ row }" >
              <el-button
                  type="primary"
                  size="mini"
                  plain
                  :disabled="row.status!=='00'"
                  @click="handleApprove('01', row)"
              >{{ $t('text.approve') }}
              </el-button>

              <el-button
                  type="danger"
                  size="mini"
                  plain
                  :disabled="row.status!=='00'"
                  @click="handleApprove('02', row)"
              >{{ $t('text.reject') }}
              </el-button>

              <el-button
                  type="info"
                  size="mini"
                  plain
                  :disabled="row.status !== '01' || row.settlementStatus !=='00'"
                  @click="handleSettle(row)"
                  :loading="loading"
              >{{ $t('text.settle') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>
    </div>
    <ApproveCredit :is-show-adopt-dialog.sync="isShowAdoptDialog" :id="id" type="withdraw" :rowData="rowData"></ApproveCredit>
    <RejectCredit :is-show-refuse-dialog.sync="isShowRefuseDialog" :id="id "></RejectCredit>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import ApproveCredit from './components/ApproveCredit.vue'
import RejectCredit from './components/RejectCredit.vue'
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  name: 'Systems',
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
    ApproveCredit: ApproveCredit,
    RejectCredit: RejectCredit,
  },

  data() {
    return {
      url: '/creditApplicationRecord/selectList',
      action: '',
      timeDate: [],
      form: {
        appId: '',
        startDate: '',
        endDate: '',
      },
      merchantList: [],
      isShowAdoptDialog: false,
      isShowRefuseDialog: false,
      id: '',
      rowData: '',
      loading: false,
      multipleSelection: [],
      strMultipleSelection: [],
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.strMultipleSelection = this.multipleSelection.map(
          ({orderId}) => orderId
      );
    },
    timeChange(e) {
      console.log(this.timeDate)
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    reset() {
      this.timeDate = []
    },
    handleApprove(type, row) {
      this.id = row.orderId
      this.rowData = row
      if (type === '01') {
        this.isShowAdoptDialog = true
      } else {
        this.isShowRefuseDialog = true
      }
    },
    handleSettle(row) {
      this.loading = true
      this.$axios
          .post('/creditApplicationRecord/settlementCreditApplicationRecord', {orderId: row.orderId})
          .then(res => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: 'success',
              })
              this.$bus.$emit('refresh') //通知刷新
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg,
              })
            }
            this.loading = false
          })
    },
    handleSettleAll() {
      this.loading = true
      this.$axios
          .post('/creditApplicationRecord/settlementCreditApplicationRecordAll',
              {orderIds: this.strMultipleSelection.join(',')})
          .then(res => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: 'success',
              })
              this.$bus.$emit('refresh') //通知刷新
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg,
              })
            }
            this.loading = false
          })
    },
    selectable(row) {
      return row.status === '01' && row.settlementStatus === '00';
    },
  },
  created() {
    this.$axios
        .get('/merchant/selectListForOption', {params: {}})
        .then(res => {
          this.merchantList = res.data
          if (this.merchantList.length === 1) {
            this.form.appId = this.merchantList[0].value
            this.$bus.$emit('refresh')
          }
        })
  },
}
</script>

<style scoped>

.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>